var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('audio',{staticStyle:{"display":"none"},attrs:{"src":_vm.audioPath,"loop":"","controls":"","autoplay":"","id":"bgAudio"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }